import { useEffect, useState } from 'react'
import { FlipHorizontal } from 'lucide-react'
import { useTools } from '../../ToolProvider.jsx'
import { useDataModelo3dContext } from '../../DataProvider.jsx'
import { resolveProductType } from '../../../../products/registry.js'

/**
 * Botón de dar la vuelta al llavero, para pintar por la cara de atrás.
 *
 * Sólo llaveros: es el único producto con dos caras que se dibujen. Se suscribe
 * a `face:changed` porque quien manda es el lienzo, no React — igual que hace el
 * gestor de capas con `layer:changed`.
 */
const FlipFaceButton = () => {
    const { canvas, getEditingFace, onSetEditingFace } = useTools()
    const dataModelo3d = useDataModelo3dContext()
    const [face, setFace] = useState('front')

    useEffect(() => {
        if (!canvas) return undefined
        const refresh = () => setFace(getEditingFace())
        refresh()
        canvas.on('face:changed', refresh)
        return () => canvas.off('face:changed', refresh)
    }, [canvas, getEditingFace])

    if (resolveProductType(dataModelo3d) !== 'keyring') return null

    const onBack = face === 'back'
    const label = onBack ? 'Volver a la cara de delante' : 'Dar la vuelta y pintar por detrás'
    return (
        <button
            type="button"
            className={`btn btn-sm btn-circle tooltip tooltip-top ${onBack ? 'btn-primary' : 'btn-ghost'}`}
            data-tip={label}
            aria-label={label}
            aria-pressed={onBack}
            onClick={() => onSetEditingFace(onBack ? 'front' : 'back')}
        >
            <FlipHorizontal className="h-[1.1rem] w-[1.1rem]" />
        </button>
    )
}

export default FlipFaceButton
